export const BUSINESS_TYPES = [
  { id: 'all', label: 'All Contracts' },
  { id: 'restaurant-cafe', label: 'Restaurant / Cafe' },
  { id: 'retail-store', label: 'Retail Store' },
  { id: 'beauty-spa', label: 'Beauty Salon / Spa' },
  { id: 'cleaning-home', label: 'Cleaning & Home Services' },
  { id: 'professional', label: 'Professional Services' },
  { id: 'event-ticketing', label: 'Event Ticketing' },
  { id: 'travel-hospitality', label: 'Travel & Hospitality' },
  { id: 'health-wellness', label: 'Health & Wellness' },
  { id: 'regulated-categories', label: 'Regulated Categories' },
  { id: 'regional-ambassador', label: 'Regional Sales / Agent' },
];

export const BUSINESS_TYPE_CONTRACTS = {
  'restaurant-cafe': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-005', 'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-010',
    'BR-B2B-029', 'BR-B2B-046', 'BR-B2B-047', 'BR-B2B-048', 'BR-B2B-053', 'BR-B2B-054'
  ],
  'retail-store': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-005', 'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-010',
    'BR-B2B-030', 'BR-B2B-046', 'BR-B2B-047'
  ],
  'beauty-spa': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-005', 'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-010',
    'BR-B2B-031', 'BR-B2B-046', 'BR-B2B-047'
  ],
  'cleaning-home': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-032', 'BR-B2B-046'
  ],
  'professional': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-033'
  ],
  'event-ticketing': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-010', 'BR-B2B-015',
    'BR-B2B-034', 'BR-B2B-047'
  ],
  'travel-hospitality': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-035'
  ],
  'health-wellness': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-036'
  ],
  'regulated-categories': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-002', 'BR-B2B-003', 'BR-B2B-004',
    'BR-B2B-007', 'BR-B2B-008', 'BR-B2B-009', 'BR-B2B-037'
  ],
  'regional-ambassador': [
    'BR-B2B-000', 'BR-B2B-001', 'BR-B2B-038', 'BR-B2B-039', 'BR-B2B-040',
    'BR-B2B-041', 'BR-B2B-042', 'BR-B2B-043', 'BR-B2B-044'
  ]
};

export const SMART_BUNDLES = {
  'restaurant-cafe': {
    title: 'Restaurant & Cafe Onboarding Bundle',
    description: 'Minimum required documents for food, dining, and beverage providers to launch offers.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-029'],
    operational: ['BR-B2B-046', 'BR-B2B-047', 'BR-B2B-048', 'BR-B2B-053', 'BR-B2B-054']
  },
  'retail-store': {
    title: 'Retail Store Onboarding Bundle',
    description: 'Standard package for retail shops, physical locations, and boutiques.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-030'],
    operational: ['BR-B2B-046', 'BR-B2B-047']
  },
  'beauty-spa': {
    title: 'Beauty Salon & Spa Bundle',
    description: 'Recommended package for salons, spas, and wellness/grooming operations.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-031'],
    operational: ['BR-B2B-046', 'BR-B2B-047']
  },
  'cleaning-home': {
    title: 'Cleaning & Home Services Bundle',
    description: 'Standard setup files for residential or commercial service providers.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-032'],
    operational: ['BR-B2B-046']
  },
  'professional': {
    title: 'Professional Services Onboarding Bundle',
    description: 'Core agreement and professional consulting services rider.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-033'],
    operational: []
  },
  'event-ticketing': {
    title: 'Event Ticketing & Booking Bundle',
    description: 'Required documents for venue ticketing, event hosts, and booking platforms.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-034'],
    operational: ['BR-B2B-047']
  },
  'travel-hospitality': {
    title: 'Travel & Hospitality Bundle',
    description: 'Standard documents for travel agents, hotels, tours, or transport providers.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-035'],
    operational: []
  },
  'health-wellness': {
    title: 'Health & Wellness Bundle',
    description: 'Framework for gyms, trainers, and local fitness centers.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-036'],
    operational: []
  },
  'regulated-categories': {
    title: 'Regulated Category Onboarding Bundle',
    description: 'Core agreement with high-risk category review riders.',
    core: ['BR-B2B-001', 'BR-B2B-002'],
    rider: ['BR-B2B-037'],
    operational: []
  },
  'regional-ambassador': {
    title: 'Regional Ambassador & Agency Bundle',
    description: 'Complete commission, licensing, and agency agreements for regional sales representatives.',
    core: ['BR-B2B-001'],
    rider: ['BR-B2B-038'],
    operational: ['BR-B2B-042', 'BR-B2B-043', 'BR-B2B-044']
  }
};
